export default {
  option: provided => ({
    ...provided,
    padding: 10,
  }),
  control: provided => ({
    ...provided,
    marginTop: -2.5,
    minHeight: 15,
    padding: 0,
    overflowY: 'auto',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  menu: provided => ({
    ...provided,
    paddingTop: 0,
  }),
  valueContainer: provided => ({
    ...provided,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ':hover': {
      backgroundColor: '#027bff',
      color: 'white',
    },
  }),
};
